import React, {useCallback, useState} from 'react'
import {useDropzone} from 'react-dropzone'
import uploadIcon from '../../../images/upload-icon.svg'
import ProgressBar from '../../progress-bar/progress-bar.component';

import './dropzone.style.scss'
 
export const FileDropzone = ({ setCurrentFile, setErrorMessage }) => {
  const [completed, setCompleted] = useState(100);
  const supportedTypes = {
    'application/pdf': 'pdf',
    'text/xml': 'xml'
  }
  const onDrop = useCallback( file => {
    
    const name = file[0].name
    const mimetype = supportedTypes[file[0].type]
    
    if(!supportedTypes[file[0].type]) {
      setErrorMessage('Datoteka koju želite učitati nije podržana.')
      return;
    } 
    
    if(file[0].size > 41943040) {
      setErrorMessage('Datoteka je prevelika')
      return
    }

    setErrorMessage(null)
    let reader = new FileReader()
  
    reader.readAsDataURL(file[0])
 
    reader.onprogress = (e) => {
      setCompleted(Math.floor((e.loaded/e.total)*100))

    }

    reader.onload = e => {
      const base64Document = reader.result.split(",")[1]
      
      setCurrentFile({
        name,
        base64Document,
        mimetype
      })

    }

  }, [])
  const {getRootProps, getInputProps} = useDropzone({onDrop})
  return (
    <div className="dropzone-wrapper">
      
       
      { (completed < 100) ? <ProgressBar completed={ completed }/> : (
        <div className="dropzone" {...getRootProps()}>
          <input {...getInputProps()} />
          <div className="dropzone-content">
            <img src={uploadIcon} alt=""/>
          </div>
          <div className="dropzone-content dropzone-content-middle">
            <p className="dropzone-text">Dovucite željene dokumente ovdje ili ih odaberite sa računala.</p>
          </div>
          <div className="dropzone-content">
            <button className="form-button" onClick={e => e.preventDefault()}>Odaberi dokument</button>
            <p className="dropzone-notification">Podržane datoteke: PDF, XML</p>
          </div>
          
          </div>
        )}
          
    
        
       
    </div>
  )
}

